import { config } from '@iheartjane/config';
import { useRuntimeConfig } from '@iheartjane/runtime-config';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useBuildVersion } from '@jane/shared-ecomm/data-access';

const DEFAULT_POLLING_INTERVAL_SECONDS = 60 * 5;

interface UseForceClientRefreshParams {
  currentVersion?: string;
  pollingIntervalSeconds?: number;
}

/**
 * Reloads the page once a newer build is deployed, except during checkout.
 */
export const useForceClientRefresh = ({
  currentVersion = config.buildVersion,
  pollingIntervalSeconds = DEFAULT_POLLING_INTERVAL_SECONDS,
}: UseForceClientRefreshParams = {}) => {
  const { pathname } = useLocation();
  const { isPartnerHosted } = useRuntimeConfig();
  const { data } = useBuildVersion({
    currentVersion,
    pollingIntervalMs: pollingIntervalSeconds * 1000,
    versionUrl: isPartnerHosted
      ? `${config.deployPublicPath}version.json`
      : '/version.json',
  });

  const hasNewVersion = data.buildVersion !== currentVersion;

  useEffect(() => {
    if (hasNewVersion && !pathname.includes('checkout')) {
      window.location.reload();
    }
  }, [hasNewVersion, pathname]);
};
